import React, { useEffect, useState } from "react";
import logoBg from "../../assets/products/logoBg.png";
import { Link } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Product2 from "../Product2";
import { Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../../styles/products.css";
import { useTranslation } from "react-i18next";
import { fetchProducts } from "../../redux/ecommerce/productsSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchBestPro } from "../../redux/ecommerce/bestSellerProductsSlice";

const BestSellers = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();

  const { bestProducts, status, error } = useSelector(
    (state) => state.bestProducts
  );


  useEffect(() => {
    if (status === "succeeded") {
      dispatch(fetchBestPro());
    }
  }, [status, dispatch]);

  console.log("bestProducts", bestProducts)

  const [phone, setPhone] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setPhone(window.innerWidth <= 1280 ? true : false);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (status === "loading") {
    return (
      <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
        Loading products...
      </p>
    );
  }



  return (
    <div className="bg-[#14294F] min-h-[600px] relative py-10 best">
      <h3 className="text-[#FB7C3E] text-4xl max-lg:text-2xl font-semibold text-center relative z-10">
        {t("Top Best Sellers")}
      </h3>
      <img src={logoBg} className="w-[400px] h-[600px] absolute left-0 top-0" />
      <div className={`grid grid-cols-3 max-lg:grid-cols-1 gap-10 lg:items-center ${language == "en" ? "pl-20" : "pr-20"} max-lg:pl-5 z-10 relative mt-20 max-lg:mt-10`}>
        <div>
          <h3 className="text-white text-3xl max-lg:text-2xl font-semibold">
            {t("Explore our best selling products")}
          </h3>
          <Link
            to="/"
            className="text-[#FE9B71] mt-8 rounded-full border-4 border-[#FB7C3E] w-[250px] h-[50px] text-xl flex items-center justify-center font-semibold"
          >
            {language == "en" ? (
              <>
                {t("Explore all")}
                <RightOutlined className="ml-8 max-lg:ml-2 font-bold" />
              </>
            ) : (
              <>
                {t("Explore all")}
                <LeftOutlined className="mr-8 max-lg:mr-2 font-bold" />
              </>
            )}
          </Link>
        </div>
        <div className="col-span-2">
          <Swiper
            spaceBetween={50}
            slidesPerView={phone === true ? 1 : 2.5}
            pagination={{ clickable: true }}
            onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => console.log(swiper)}
            modules={[Pagination, Scrollbar, A11y]}
          >
            {/* <SwiperSlide>
              <Product2 />
            </SwiperSlide>
            <SwiperSlide>
              <Product2 />
            </SwiperSlide>
            <SwiperSlide>
              <Product2 />
            </SwiperSlide>
            <SwiperSlide>
              <Product2 />
            </SwiperSlide> */}
            {bestProducts?.map((product, idx) => (
              <SwiperSlide key={product.id || idx}>
                <Product2
                  id={product.id}
                  color_id={product.colors?.[0]?.id || null}
                  count={1}
                  image={`https://ecommerce.samoolah.com${product.image}`}
                  name={language === "en" ? product.name_en : product.name_ar}
                  price={product.price}
                  link={product.id}
                  favorite={product.favorite}
                />
              </SwiperSlide>
            ))}
            {
              bestProducts?.length === 0 &&
              (
                <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
                  No products found.
                </p>
              )
            }
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default BestSellers;
